import React, { useState } from 'react';
import ReplayIcon from '@mui/icons-material/Replay';
import MemberComponent from '../components/memberComponent';
import { Grid, Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CustomTooltip from '../components/customTooltip';
import {
  configuratorService,
  configuratorServiceStep
} from '../../services/configuratorService';

function DynamicStackedNav(props) {
  const {
    startData,
    isVE,
    lang,
    sessionDataItems,
    handleOnChange,
    handleStartData,
    isLoading,
    imageUrls
  } = props;

  const [option, setOption] = useState(0);
  const [collapseStatus, setCollapseStatus] = useState([
    { name: '', value: '' }
  ]);

  const createRequest = (data, configState) => {
    let requestData = {
      divisionId: sessionDataItems?.manufacturingDivision,
      configState: configState ? configState : startData.configState,
      configModel: sessionDataItems?.configModel,
      ...data
    };
    return requestData;
  };

  const members = () => {
    return startData?.uiGroup?.members;
  };

  const clearSelections = () => {
    handleOnChange('', 'resetall', '');
    setOption(0);
  };

  const onActiveTabClick = async (i, name) => {
    isLoading(true);
    setOption(i);

    let requestData = createRequest({
      step: name
    });
    let response;
    if (name == 'product_selection')
      response = await configuratorService(requestData);
    else response = await configuratorServiceStep(requestData);

    handleStartData(response ? response : startData);
    isLoading(false);
  };

  const currentStep = () => {
    return startData.tactonModel.steps.filter(x => x.current);
  };

  const getIsGroupRootMembers = () => {
    let step = currentStep();
    if (step) {
      let members = step[0].rootGroup.members.filter(
        x => !x.name.includes('info_group') && !x.name.includes('summary_group')
      );
      return members;
    } else {
      return null;
    }
  };
  const showHeader = members => {
    return (
      members.properties && members.properties.ph_show_group_heading == 'yes'
    );
  };

  const isGroupOpen = member => {
    var status;
    var item = collapseStatus.filter(x => x.name === member.name);
    if (item?.length > 0) {
      status = item[0].value;
    }
    if (!status && member.properties.ph_group_min == 'yes') {
      return false;
    }

    return status !== false;
  };

  const toggleCollapse = member => {
    const index = collapseStatus.findIndex(item => item.name === member.name);
    console.log('Status');
    console.log(index);

    if (index === -1) {
      setCollapseStatus([
        ...collapseStatus,
        { name: member.name, value: true }
      ]);
    } else {
      setCollapseStatus(
        collapseStatus.map(item => {
          if (item.name === member.name) {
            return { ...item, value: !item.value };
          } else {
            return item;
          }
        })
      );
    }
  };

  const getCollapseIcon = member => {
    var status;

    var item = collapseStatus.filter(x => x.name === member.name);
    if (item?.length > 0) {
      status = item[0].value;
    }
    if (
      status == true ||
      (status === undefined && member.properties.ph_group_min != 'yes')
    )
      return 'm';

    return 'p';
  };

  return (
    <div>
      {startData?.dynamicSteps && (
        <>
          <Grid className="dynamic-stack-option">
            {startData?.dynamicSteps?.map((item, i) => {
              return (
                <Box
                  key={i}
                  className="headBoxLeft"
                  sx={
                    option == i
                      ? {
                          border: '1px solid #ffb91d',
                          borderBottom: '4px solid #ffb91d'
                        }
                      : {}
                  }
                  onClick={() => onActiveTabClick(i, item.name)}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    className="navigationButtonInBox"
                    sx={
                      option == i
                        ? {
                            backgroundColor: '#ffb91d !important'
                          }
                        : {}
                    }
                    onClick={() => onActiveTabClick(i, item.name)}
                  >
                    {i + 1}
                  </Button>
                  <Typography className="headText">
                    {item.description}
                  </Typography>
                </Box>
              );
            })}
          </Grid>
          <Grid>
            {startData?.dynamicSteps?.map((item, i) => {
              return (
                <CustomTooltip title={item.description} key={i} placement="top">
                  <Button
                    variant="outlined"
                    size="small"
                    className="navigationButton"
                    sx={
                      option == i
                        ? {
                            backgroundColor: '#ffb91d !important'
                          }
                        : {}
                    }
                    onClick={() => onActiveTabClick(i, item.name)}
                  >
                    {i + 1}
                  </Button>
                </CustomTooltip>
              );
            })}
          </Grid>
        </>
      )}
      {!isVE && (
        <a className="clear-selections" onClick={() => clearSelections()}>
          <ReplayIcon className="replay-icon-clear" />
          {lang.RESET_SELECTIONS_TO_BASE_MODEL}
        </a>
      )}
      <div className="options-content">
        {!startData.isGroup ? (
          members()?.map((member, index) => {
            return (
              <div key={member.name + '_' + index}>
                <MemberComponent
                  member={member}
                  startData={startData}
                  handleOnChange={handleOnChange}
                  sessionDataItems={sessionDataItems}
                  lang={lang}
                  imageUrls={imageUrls}
                />
              </div>
            );
          })
        ) : (
          <>
            {getIsGroupRootMembers().map(rootMembers => {
              return rootMembers.members.map((members, index) => {
                return showHeader(members) &&
                  members.properties.hidden != 'yes' ? (
                  <Grid container key={members.name + '_' + index}>
                    <Grid item md={11} lg={11}>
                      <h6 className="group-option-category">
                        {members.description}
                      </h6>
                    </Grid>
                    <Grid
                      item
                      md={1}
                      lg={1}
                      className="option-collapse-icon"
                      onClick={() => toggleCollapse(members)}
                    >
                      {getCollapseIcon(members) === 'p' ? (
                        <AddIcon />
                      ) : (
                        <RemoveIcon />
                      )}
                    </Grid>
                    {isGroupOpen(members) && (
                      <Grid item xs={12}>
                        <MemberComponent
                          member={members}
                          startData={startData}
                          handleOnChange={handleOnChange}
                          sessionDataItems={sessionDataItems}
                          showGroupHeader={false}
                          lang={lang}
                          imageUrls={imageUrls}
                        />
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  <div key={members.name + '_' + index}>
                    <MemberComponent
                      member={members}
                      startData={startData}
                      handleOnChange={handleOnChange}
                      sessionDataItems={sessionDataItems}
                      showGroupHeader={false}
                      lang={lang}
                      imageUrls={imageUrls}
                    />
                  </div>
                );
              });
            })}
          </>
        )}
      </div>
    </div>
  );
}

export default DynamicStackedNav;
